import { CancellationBlockedReason, CancellationsAccessMessageConfig } from '../../../../types';

/**
 * Processes eligibility checks to determine frontend notification
 * We'll show the message if
 * - the user is able to make ineligibility checks in the first place (`baseAccess = true`)
 * - they are ineligible for cancellation (`fullAccess = false`)
 * - and we have a reason for their ineligibility from the API (`reasonBlocked` exists)
 *
 * @param baseAccess - Foundational, step one checks via a FE prerequisite check and BE pre-eligibility check (page load)
 * @param fullAccess - Comprehensive, step two checks via e.g. API response (button click)
 * @param ineligibleReason - Reason provided by the core cancellation API for ineligibility
 *
 * @returns object with `show` flag and `reasonBlocked` message for displaying ineligibility info
 *
 */
export const getCancellationsAccessMessageConfig = (
	baseAccess: boolean,
	fullAccess: boolean,
	ineligibleReason: CancellationBlockedReason,
): CancellationsAccessMessageConfig => {
	const reasonBlocked = baseAccess ? ineligibleReason : undefined;
	return {
		show: baseAccess && !fullAccess && !!reasonBlocked,
		reasonBlocked,
	};
};
